import { clip, prettyErrors } from "./logging";
import { parseError, isParseError } from "./errors";
import { runValidationsFor } from "./tagValidations";
export { prettyErrors } from "./logging";
export const parse = (text) => {
    if (!text.length)
        throw new Error(`I've no content to parse - text is empty!`);
    const errors = [];
    const warns = [];
    let location = 0;
    let char = text[0];
    const eat = (chars) => {
        let found = 0;
        while (chars.includes(char)) {
            next();
            found++;
        }
        return { eat: true, chars, found };
    };
    const eatWhitespace = () => {
        const skip = [' ', '\t', '\r', '\n', '\b'];
        return eat(skip);
    };
    const next = (expect) => {
        if (expect) {
            if (!text.slice(location, location + expect.length).startsWith(expect))
                throw parseError(`I was expecting "${expect.replace('\n', '\\n')}" but I found "${clip(text.slice(location, location + expect.length))}".`, location);
        }
        location += (expect === null || expect === void 0 ? void 0 : expect.length) || 1;
        char = text[location];
        return char;
    };
    const regexNext = (regex, ahead, msgGen) => {
        var _a, _b, _c;
        const input = text.slice(location, location + ahead);
        const match = input.match(regex);
        if (!((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.target))
            throw parseError(msgGen(regex + "", text.slice(location, location + ahead)), location);
        next((_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.target);
        return (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.target;
    };
    const peek = (length) => text.slice(location, location + length);
    const isEof = () => location === text.length;
    const skipToNextNl = () => {
        while (!isEof() && char !== '\n')
            next();
        next('\n');
    };
    const items = () => {
        const items = [];
        // if Provider/Database/Content header is present, skip it
        if (!isEof() && peek(9) === 'Provider:') {
            skipToNextNl();
            if (!isEof() && peek(9) === 'Database:')
                skipToNextNl();
            if (!isEof() && peek(8) === 'Content:')
                skipToNextNl();
        }
        while (!isEof()) {
            eatWhitespace();
            let item;
            try {
                item = matchItem();
                items.push(item);
            }
            catch (e) {
                if (!isParseError(e))
                    throw e;
                errors.push(e);
                // lets try to see if there is another item
                while (peek(5) !== '\nPMID' && !isEof())
                    next();
            }
            eatWhitespace();
        }
        return items;
    };
    const matchItem = () => {
        const startLocation = location;
        const tags = [
            matchTag('PMID'),
            ...matchTags(),
        ];
        const endLocation = location;
        return {
            type: 'item',
            tags,
            startLocation,
            endLocation,
        };
    };
    const matchTags = () => {
        const results = [];
        while (!isEof()) {
            results.push(matchTag());
            const shouldBreak = peek(1) === '\n';
            if (shouldBreak)
                break;
        }
        return results;
    };
    const matchTag = (name) => {
        const { found: prefixSpaceFound } = eat([' ']);
        const tag = regexNext(/^(?<target>[a-zA-z0-9]{2,6}).*/, 6, (expected, found) => `I was searching for${name ? "" : " a"} tag${name ? ' "' + name + '' : ''}, but I couldn't find it. Instead I found "${clip(found)}."`);
        if (name && tag !== name)
            throw parseError(`I expected to find tag ${name} but instead found ${tag}.`, location);
        const { found: spacesBeforeDash } = eat([' ']);
        next('-');
        if (char !== ' ') {
            if (tag !== 'ER')
                warns.push({
                    message: `I found "${char}" after "-" while defining tag ${tag}. When defining tags a space should follow after "-".`,
                    location,
                });
        }
        else {
            next(' ');
        }
        let content = '';
        const moreContent = () => {
            if (isEof())
                return false;
            const newTagStarts = peek(10)
                .match(/^\n[A-Z0-9]{2,6} *-/);
            if (newTagStarts)
                return false;
            if (peek(2) === '\n\n')
                return false;
            next('\n');
            return true;
        };
        do {
            while (char !== '\n' && !isEof()) {
                content += char;
                next();
            }
        } while (moreContent());
        if (peek(1) === '\n')
            next('\n');
        runValidationsFor(tag, warns, content, location);
        return { type: 'tag', tag, content };
    };
    return {
        items: items(),
        errors,
        warns,
        prettyErrors: prettyErrors(text, errors),
        prettyWarns: prettyErrors(text, warns),
    };
};
